export default {
  notfound: {
    title: 'Diese Seite wurde noch nicht erstellt',
    hint: 'Erzählen Sie mir mehr über diese Seite, damit ich sie erstellen kann',
  },
};